// extracted by mini-css-extract-plugin
export default {"avatarWithInitials":"EmailUser_avatarWithInitials__2w5eV"};